import { FloatingNavigationOpenMenuButton } from "@src/appV2/redesign/components/FloatingNavigation/OpenMenuButton";
import {
  FloatingNavigationTab,
  FloatingNavigationTabs,
} from "@src/appV2/redesign/components/FloatingNavigation/Tabs";
import { useEffect, useState } from "react";
import { useFloatingTabs } from "../../../../appV2/redesign/AppLayout/Mobile/FloatingTabsContext";
import { AppLayoutPageWrapperMobile } from "@src/appV2/redesign/AppLayout/Mobile/PageWrapperMobile";
import { AppLayoutWrapperMobile } from "./Wrapper";
import { NavigationMenuDrawerMobile } from "./Navigation/NavigationMenuDrawer";
import { NavigationMenuHeaderMobile } from "./Navigation/NavigationMenuHeader";
import { NavigationMenuFooterMobile } from "./Navigation/NavigationMenuFooter";
import { NavigationMenuItemsMobile } from "./Navigation/NavigationMenuItems";
import { NavigationMenuItemsContainerMobile } from "@src/appV2/redesign/AppLayout/Mobile/Navigation/NavigationMenuItemsContainer";
import { NavigationMenuSectionTitleDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuSectionTitle";
import { NavigationMenuItemDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuItem";
import { CurrentlyViewedSectionDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/CurrentlyViewedSection";
import { Box } from "@mui/material";
import { Platform } from "@src/mobile/utils/platform";
import { AllRoutes } from "../Shared/Navigation/routes/AllRoutes";
import { RecentlyViewedSectionDesktop } from "../Desktop/Navigation/RecentlyViewedSection";

export interface AppLayoutMobileProps {
  admin: boolean;
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  userName: string;
  userId: string;
  logoutConfirm: () => void;
  renderStartPage: () => JSX.Element | null;
}

function Divider() {
  return (
    <Box
      sx={(theme) => ({
        height: "1px",
        backgroundColor: theme.palette.navbar?.sectionDivider,
      })}
    />
  );
}

export function AppLayoutMobile(props: AppLayoutMobileProps) {
  const {
    admin,
    isAdmin,
    isWorker,
    isWorkplace,
    userName,
    userId,
    logoutConfirm,
    renderStartPage,
  } = props;

  const [showSidenav, setShowSidenav] = useState(false);
  const { tabs, showTabs, activeTab, setActiveTab } = useFloatingTabs();

  useEffect(() => {
    if (!Platform.isMobile) {
      return;
    }

    async function updateStatusBar() {
      const { StatusBar, Style } = await import("@capacitor/status-bar");
      await StatusBar.setStyle({ style: showSidenav ? Style.Dark : Style.Light });
    }

    void updateStatusBar();
  }, [showSidenav]);

  return (
    <AppLayoutWrapperMobile>
      <NavigationMenuDrawerMobile
        open={showSidenav}
        onClose={() => {
          setShowSidenav(false);
        }}
      >
        <NavigationMenuHeaderMobile onClose={() => setShowSidenav(false)} />

        <Divider />

        <NavigationMenuItemsContainerMobile>
          <NavigationMenuItemsMobile
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            closeSidenav={() => setShowSidenav(false)}
          />
          <CurrentlyViewedSectionDesktop
            admin={admin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            currentName={userName}
            currentUserId={userId}
          />
          <RecentlyViewedSectionDesktop admin={admin} />
          <NavigationMenuSectionTitleDesktop>Logout</NavigationMenuSectionTitleDesktop>
          <NavigationMenuItemDesktop
            iconType="door-straight"
            isSelected={false}
            onClick={() => {
              setShowSidenav(false);
              logoutConfirm();
            }}
          >
            Logout
          </NavigationMenuItemDesktop>
        </NavigationMenuItemsContainerMobile>

        <Divider />

        <NavigationMenuFooterMobile closeSidenav={() => setShowSidenav(false)} />
      </NavigationMenuDrawerMobile>

      <AppLayoutPageWrapperMobile>
        <AllRoutes
          admin={admin}
          isAdmin={isAdmin}
          isWorker={isWorker}
          isWorkplace={isWorkplace}
          renderStartPage={renderStartPage}
        />
      </AppLayoutPageWrapperMobile>

      {tabs.length > 0 && showTabs && (
        <FloatingNavigationTabs
          value={activeTab}
          onChange={(_, newValue) => {
            setActiveTab(newValue as string);
            const tab = tabs.find((t) => t.value === newValue);
            if (tab?.onClick) {
              tab.onClick();
            }
          }}
        >
          {tabs.map((tab) => (
            <FloatingNavigationTab
              key={tab.value}
              iconType={tab.iconType}
              label={tab.label}
              value={tab.value}
            />
          ))}
        </FloatingNavigationTabs>
      )}

      <FloatingNavigationOpenMenuButton
        onClick={() => {
          setShowSidenav(true);
        }}
      />
    </AppLayoutWrapperMobile>
  );
}
